import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { Deparment } from "../../../types/models/ticket.model.type";
import type { ContactsState, FilterOptionsContacts } from "../../../types/states/ticket.state.type";
import { EMPTY_TEXT } from "../../../utils/enum/defaultParams.enum";

const initialState: ContactsState = {
  isFetching: false,
  data: [],
  error: undefined,
  selectedItem: undefined,
  filterOptions: {
    search: EMPTY_TEXT,
  },
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
    },
    rxSuccessFetchingData: (state, { payload }: PayloadAction<Deparment[]>) => {
      state.isFetching = false;
      state.data = payload;
      state.error = undefined;
      if (state.selectedItem) {
        const foundSelected = payload.find((e) => e.idDepartamento === state.selectedItem!.idDepartamento);
        if (!foundSelected) {
          state.selectedItem = undefined;
        } else {
          state.selectedItem = foundSelected;
        }
      }
    },
    rxErrorFetchingData: (state, { payload }: PayloadAction<string>) => {
      state.isFetching = false;
      state.data = [];
      state.error = payload;
    },
    rxSetFilterOptions: (state, { payload }: PayloadAction<FilterOptionsContacts>) => {
      state.filterOptions = payload;
    },
    rxResetFilter: (state) => {
      state.filterOptions = {
        search: EMPTY_TEXT,
      };
    },
    rxSetSelectedContact: (state, { payload }: PayloadAction<Deparment>) => {
      if (state.selectedItem) {
        state.selectedItem = state.selectedItem.idDepartamento === payload.idDepartamento ? undefined : payload;
      } else {
        state.selectedItem = payload;
      }
    },
  },
});

export const {
  rxErrorFetchingData,
  rxResetFilter,
  rxSetFilterOptions,
  rxSetSelectedContact,
  rxStartFetching,
  rxSuccessFetchingData,
} = contactsSlice.actions;
export const contactsSelector = (state: { contacts: ContactsState }) => state.contacts;
export default contactsSlice.reducer;
